import { render, staticRenderFns } from "./AdministrativeProcurementCheck.vue?vue&type=template&id=31d86b67&scoped=true"
import script from "./AdministrativeProcurementCheck.vue?vue&type=script&lang=js"
export * from "./AdministrativeProcurementCheck.vue?vue&type=script&lang=js"
import style0 from "./AdministrativeProcurementCheck.vue?vue&type=style&index=0&id=31d86b67&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d86b67",
  null
  
)

export default component.exports